import React from "react"

import { MENU_CONFIG } from "../../config/menu.config"
import { ScreenTabsLayoutElement } from "../../elements/screenTabsLayout.element"
import { PayerRatesComponent } from "../configurations/payerRates/payerRates.component"
import { OrganizationInformationComponent } from "./organizationInformation.component"
import { OrganizationUsersComponent } from "./users/organizationUsers.component"

export const OrganizationComponent: React.FunctionComponent = () => (
    <ScreenTabsLayoutElement
        tabs={MENU_CONFIG.organizationAvailableTabs}
        renderTabContent={tab => {
            switch (tab.key) {
                case "information":
                    return <OrganizationInformationComponent />

                case "users":
                    return <OrganizationUsersComponent />

                // TODO: Remove the payer rates tab once we remove the early release feature flag for configurations page
                case "payer_rates":
                    return <PayerRatesComponent />

                default:
                    return null
            }
        }}
    />
)
